import React from 'react';
import {PlusOutlined} from '@ant-design/icons';
import {Button, message, Select, Spin} from 'antd';
import {connect} from 'react-redux'
import {slideListUpdateSuccess} from '../../redux_actions/slides.action';
import {addTagToTagList} from '../../redux_actions/dashboard.action';
import querystring from "query-string";
import cookie from "react-cookies";
import {post_response} from "../../helper/request";
import {performAbortControllerTagAndSlideSearch} from "../../utils/api";


class MultipleTagAddition extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedSlides: this.props.selectedSlides,
            inputVisible: false,
            inputValue: '',
            tag_suggestions: [],
            loadingSearchResults: false,
        }
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.selectedSlides) != JSON.stringify(this.props.selectedSlides)) {
            this.setState({
                selectedSlides: this.props.selectedSlides,
                inputVisible: false,
                inputValue: '',
                tag_suggestions: [],
            });
        }
    }

    updateSearchResults = (searchResults) => {
        this.setState({
            tag_suggestions: searchResults,
            loadingSearchResults: false,
        })
    }

    performSearch = (value) => {
        this.setState({
            loadingSearchResults: true,
        })
        performAbortControllerTagAndSlideSearch('#' + value,this.updateSearchResults)
    }

    showInput = () => {
        this.setState({inputVisible: true}/*, () => this.input.focus()*/);
    }

    addSlideTag = (values) => {
        if (values.length > 0) {
            const {inputValue} = this.state;
            let {selectedSlides} = this.state;
            let stripped = ('#' + values.toString().replace('#', '').replace(' ', '')).toLowerCase();
            let fail_flag = false;
            for (let i = 0; i < selectedSlides.length; i++) {
                if (stripped && selectedSlides[i].tags.indexOf(stripped) === -1) {
                    selectedSlides[i].tags = [...selectedSlides[i].tags, {
                        title: stripped,
                        created_by: cookie.loadAll().username
                    }];
                }
            }

            let url = `/api/add_slide_tag/`;
            let val = {"title": stripped, "slide_ids": JSON.stringify(selectedSlides.map(slide => slide.morphle_id))};
            post_response(url, querystring.stringify(val))
                .then(response => {
                    if (response.status === 200 || response.status === 301 || response.status === 302) {
                        selectedSlides.forEach(slide => {
                            this.props.dispatch(slideListUpdateSuccess(slide.id, slide));
                            if (!this.props.allTags.includes(stripped)) {
                                this.props.dispatch(addTagToTagList(stripped));
                            }
                        });
                    } else if (response.status === 403 || response.status === 401 || response.status === 400) {
                        fail_flag = true;
                    }
                })
                .catch(err => {
                    fail_flag = true;
                });

            if (fail_flag) {
                message.error('Slide Update Failed', 2.5);
            } else {
                message.success('Slide Update Successful', 2.5);
            }
            this.setState({
                inputVisible: false,
                inputValue: '',
                tag_suggestions: []
            });
        } else {
            this.setState({
                inputVisible: false,
                inputValue: '',
                tag_suggestions: []
            });
        }
    }

    onBlurAction = (values) => {
        this.setState({
            inputVisible: false,
            inputValue: '',
            tag_suggestions: []
        });
    }

    //saveInputRef = input => this.input = input

    render() {
        let {tags, inputVisible, inputValue} = this.state;

        let selected = [];

        let numSuggested = this.state.tag_suggestions.length;

        let tagSuggestionsBox = numSuggested > 0 || this.state.loadingSearchResults ?
            <Select.OptGroup label={this.state.loadingSearchResults ?  <div><Spin size="small"/> <span style={{marginLeft: 5}}>{" Loading Results... "}</span></div> :
                <div><b>{numSuggested}</b> result{numSuggested > 1 ? 's' : ''} found </div>}>
                {this.state.tag_suggestions.map((item, index) => (
                    <Select.Option
                        key={index}
                        value={item.display_text}
                        label={item.display_text}
                        className='search-result-tag'
                        size='small'
                        type='tag'
                    >
                        {item.display_text} <span style={{float: "right", fontSize: 12}}></span>
                    </Select.Option>
                ))}
            </Select.OptGroup> : undefined;

        return (
            <div id={'multiple-tag-search-select'} className={'custom-dropdown-max-height'} style={{width: "100%"}}>
                {inputVisible && (
                    <Select
                        showSearch
                        allowClear
                        autoFocus
                        className="search-input"
                        showArrow={false}
                        filterOption={false}
                        notFoundContent={null}
                        mode="tags"
                        onSearch={this.performSearch}
                        onSelect={this.addSlideTag}
                        onBlur={this.onBlurAction}
                        optionLabelProp="label"
                        value={selected}
                        classname="add-tag-row-selection-input"
                        getPopupContainer={() => document.getElementById('multiple-tag-search-select')}
                        style={{width: "100%"}}
                    >
                        {tagSuggestionsBox}
                    </Select>
                )}
                {!inputVisible && (
                    <Button
                        onClick={this.showInput}
                    >
                        <PlusOutlined/> Add New Tag
                    </Button>
                )}
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        loginStatus: state.loginAlerts.loginStatus,
        urlState: state.viewerUrlReducer,
        allTags: state.dashboardReducer.allTags
    }
}

export default connect(mapStateToProps)(MultipleTagAddition)
